import { useBreadcrumbs } from '@dealstack/frontend/shared/components/Breadcrumbs/useBreadcrumbs';
import { useTranslationInvestor } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { ROUTES } from '@dealstack/frontend/investor/pages/Routing/routes';

export const useInvestmentController = () => {
	const tInvestor = useTranslationInvestor();

	useBreadcrumbs(
		[
			{
				name: tInvestor('dashboard.my_dashboard'),
				url: ROUTES.DASHBOARD,
			},
		],
		{
			skipFirst: true,
			isBlack: true,
		}
	);

	return {};
};
